var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavings({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    transform: "matrix(-1 0 0 1 60 4)",
    fill: "#D8D1C0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 1.5,
    transform: "matrix(-1 0 0 1 60 10.5)",
    fill: "#B9B29E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    transform: "matrix(-1 0 0 1 64 12)",
    fill: "#D8D1C0"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 1.5,
    transform: "matrix(-1 0 0 1 64 18.5)",
    fill: "#B9B29E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    transform: "matrix(-1 0 0 1 58 20)",
    fill: "#D8D1C0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 1.5,
    transform: "matrix(-1 0 0 1 58 26.5)",
    fill: "#B9B29E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    transform: "matrix(-1 0 0 1 54 28)",
    fill: "#D8D1C0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 1.5,
    transform: "matrix(-1 0 0 1 54 34.5)",
    fill: "#B9B29E"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    transform: "matrix(-1 0 0 1 60 36)",
    fill: "#D8D1C0"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 1.5,
    transform: "matrix(-1 0 0 1 60 42.5)",
    fill: "#B9B29E"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    transform: "matrix(-1 0 0 1 56 44)",
    fill: "#D8D1C0"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 1.5,
    transform: "matrix(-1 0 0 1 56 50.5)",
    fill: "#B9B29E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 8,
    transform: "matrix(-1 0 0 1 60 52)",
    fill: "#D8D1C0"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 1.5,
    transform: "matrix(-1 0 0 1 60 58.5)",
    fill: "#B9B29E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 40,
    r: 18,
    fill: "#004048",
    stroke: "#004048",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1327 36.0811L24.9794 36.4595V36.1622C24.9794 33.6216 23.514 31.7838 20.3738 31.7838C17.2037 31.7838 15.7981 33.5135 15.7981 35.8378C15.7981 37.7568 16.6953 38.9189 17.4131 40.2703H23.2449V41.8649H18.071C18.2505 42.3514 18.3402 42.8919 18.3402 43.4865C18.3402 45.0541 17.772 46.1892 17.0542 46.973C19.4168 47.0541 20.6729 48.2162 23.1551 48.2162C25.3383 48.2162 26.3551 46.8108 26.6243 46.4595L28 47.5405C27.1626 48.5676 25.6075 50 22.7364 50C20.0449 50 18.5794 48.6757 16.1869 48.6757C14.4523 48.6757 13.1963 49.9459 13.1963 49.9459L12 48.7027C12 48.7027 12.8075 47.8108 14.3327 47.2973C15.7981 46.3243 16.3364 45.1081 16.3364 43.6486C16.3364 43 16.1869 42.4054 15.9477 41.8649H12.5084V40.2703H15.1402C14.5421 39.1081 13.615 37.6757 13.615 35.6757C13.615 32.4865 15.9178 30 20.3738 30C24.6206 30 27.1327 32.3784 27.1327 36.0811Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavings);
export default __webpack_public_path__ + "static/media/savings.f42ac4e353251f8944a3e5eebcb9468d.svg";
export { ForwardRef as ReactComponent };